export default {
  NO_CONSENT: 'You must accept the data treatment',
  EMPTY_FIELDS: 'There are empty required fields in the form.',
  PASSWORDS_DONT_MATCH: 'The passwords do not match.',
  MIN_PASSWORD_LENGTH: 'The password must have a minimum of 8 characters',
  USERNAME_IS_REQUIRED: 'Il campo username è obbligatorio',
};
